import {Injectable} from '@angular/core';
import {LabelExpressionUtilityService} from '../label-expression-utility-service';
import {LabelExpressionBuildService} from './label-expression-build.service';
import {labelProperties, Attributes, SubTypeMap} from '../../../../common/models/label-expression.model';
import {PlanModelService} from '../../../../common/service/plan-model.service';

@Injectable({
    providedIn: 'root'
})
export class LotLabelExpressionBuilderService {
    title = 'LotLabelExpressionBuilder';
    subTypeMap: SubTypeMap = [];

    constructor(
        private labelExpressionBuildService: LabelExpressionBuildService,
        private labelExpressionUtilityService: LabelExpressionUtilityService,
        private planModelService: PlanModelService
    ) {
        this.init();
    }

    private init() {
        this.subTypeMap[1] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[2] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[3] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[4] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[9] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[12] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[27] = {function: this.buildLotAnnotationFreehold.bind(this)};

        this.subTypeMap[5] = {function: this.buildLotAnnotationFreehold.bind(this)};

        this.subTypeMap[6] = {function: this.buildLotAnnotationOther.bind(this)};
        this.subTypeMap[15] = {function: this.buildLotAnnotationOther.bind(this)};
        this.subTypeMap[7] = {function: this.buildLotAnnotationOther.bind(this)};
        this.subTypeMap[8] = {function: this.buildLotAnnotationOther.bind(this)};

        this.subTypeMap[10] = {function: this.buildLotAnnotationFreehold.bind(this)};
        this.subTypeMap[11] = {function: this.buildLotAnnotationFreehold.bind(this)};
    }

    build(attributes: Attributes, polygons: any) {
        return this.labelExpressionBuildService.build(this.title, this.subTypeMap, attributes, polygons);
    }

    formatLabel(value: string, size: number, normal: boolean) {
        return this.labelExpressionUtilityService.formatLabel(value, size, normal);
    }

    getLabelProperties(fontSize: string, fontStyle: string, textAnchor: string, attributes: string) {
        return this.labelExpressionUtilityService.getLabelProperties(
            fontSize,
            fontStyle,
            textAnchor,
            this.labelExpressionUtilityService.encodeSpecialCharacters(attributes)
        );
    }

    buildLotAnnotationFreehold(attributes: Attributes, polygons: any) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        let attribute5 = '';
        let attribute6 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let labelValue = '';
        let arealabelValue = '';
        let subType = attributes.featuresubtype;
        let prefix = '';

        if (attributes.attribute1) {
            if (subType === 1 || subType === 2 || subType === 3 || subType === 4 || subType === 9 || subType === 12 || subType === 27) {
                prefix = this.planModelService.getModel().planPurpose.partLotPrefix;
                prefix = prefix !== null && (polygons !== undefined && polygons.length > 1) ? prefix + ' ' : '';
            }
            if (subType === 5) {
                prefix = polygons !== undefined && polygons.length > 1 ? 'Pt. ' : '';
                prefix = prefix + 'CP ';
            }

            labelValue = prefix + attributes.attribute1;
            attribute1 = this.formatLabel(labelValue, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', labelValue));
        }

        if (attributes.attribute2) {
            if (!isNaN(attributes.attribute2)) {
                let area = parseFloat(attributes.attribute2);
                if (area >= 10000) {
                    area = area / 10000;
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 4);
                    arealabelValue = roundedNumber + 'ha';
                } else {
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 0);
                    arealabelValue = roundedNumber + 'm' + '\u00b2';
                }

                attribute2 = this.formatLabel(arealabelValue, 10, false) + '\n';
                labels.push(this.getLabelProperties('10em', 'italic', 'middle', arealabelValue));
            }
        }

        if (attributes.attribute3 && polygons && polygons.length > 1) {
            if (parseFloat(attributes.attribute3) !== parseFloat(attributes.attribute2)) {
                let area = attributes.attribute3;
                if (area >= 10000) {
                    area = area / 10000;
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 4);
                    arealabelValue = roundedNumber + 'ha';
                } else {
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 0);
                    arealabelValue = roundedNumber + 'm' + '\u00b2';
                }

                attribute3 = "<FNT name='Arial' size='10'>" + '(' + '<ITA>' + arealabelValue + ')' + '</ITA>' + '</FNT>' + '\n';
                labels.push([
                    this.getLabelProperties('10em', 'normal', 'middle', '('),
                    this.getLabelProperties('10em', 'italic', 'middle', arealabelValue),
                    this.getLabelProperties('10em', 'normal', 'middle', ')')
                ]);
            }
        }

        if (attributes.attribute4) {
            attribute4 = this.formatLabel((attributes.attribute4).toUpperCase(),
                (attributes.attribute4).toUpperCase().includes("ROAD WIDENING") ? 10 : 14, false) + '\n';
            labels.push(this.getLabelProperties(
                (attributes.attribute4).toUpperCase().includes("ROAD WIDENING") ? '10em' : '14em',
                'italic', 'middle', (attributes.attribute4).toUpperCase()));
        }

        if (attributes.attribute5) {
            attribute5 = this.formatLabel(attributes.attribute5.toUpperCase(), 14, true) + '\u00A0\u00A0\u00A0' + '\n';
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', attributes.attribute5.toUpperCase()));
        }

        if (attributes.attribute6) {
            labelValue = attributes.attribute6.toUpperCase() + '\u00A0\u00A0\u00A0';
            attribute6 = this.formatLabel(labelValue, 14, true);
            labels.push(this.getLabelProperties('14em', 'normal', 'middle', labelValue));
        }

        labelValue = (attribute1 + attribute2 + attribute3 + attribute4 + attribute5 + attribute6).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }

    buildLotAnnotationOther(attributes: Attributes, polygons: any) {
        let attribute1 = '';
        let attribute2 = '';
        let attribute3 = '';
        let attribute4 = '';
        let labels = [];
        let labelProperties = {} as labelProperties;
        let labelValue = '';

        if (attributes.attribute1) {
            attribute1 = this.formatLabel(attributes.attribute1, 14, false) + '\n';
            labels.push(this.getLabelProperties('14em', 'italic', 'middle', attributes.attribute1));
        }

        if (attributes.attribute2) {
            attribute2 = this.formatLabel(attributes.attribute2.toUpperCase(), 10, true) + '\n';
            labels.push(this.getLabelProperties('10em', 'normal', 'middle', attributes.attribute2.toUpperCase()));
        }

        let roundedNumber = undefined;
        let area = undefined;
        let arealabelValue = '';

        if (attributes.attribute3) {
            if (!isNaN(attributes.attribute3)) {
                area = parseFloat(attributes.attribute3);
                if (area >= 10000) {
                    area = area / 10000;
                    roundedNumber = this.labelExpressionUtilityService.round(area, 4);
                    arealabelValue = roundedNumber + 'ha';
                } else {
                    roundedNumber = this.labelExpressionUtilityService.round(area, 0);
                    arealabelValue = roundedNumber + 'm' + '\u00b2';
                }

                attribute3 = this.formatLabel(arealabelValue, 10, false) + '\n';
                labels.push(this.getLabelProperties('10em', 'italic', 'middle', arealabelValue));
            }
        }

        if (attributes.attribute4 && polygons !== undefined && polygons.length > 1) {
            if (parseFloat(attributes.attribute4) !== parseFloat(attributes.attribute3)) {
                area = attributes.attribute4;

                if (area >= 10000) {
                    area = area / 10000;
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 4);
                    arealabelValue = roundedNumber + 'ha';
                } else {
                    let roundedNumber = this.labelExpressionUtilityService.round(area, 0);
                    arealabelValue = roundedNumber + 'm' + '\u00b2';
                }

                attribute4 = "<FNT name='Arial' size='10'>" + '(' + '<ITA>' + arealabelValue + ')' + '</ITA>' + '</FNT>' + '\n';
                labels.push([
                    this.getLabelProperties('10em', 'normal', 'middle', '('),
                    this.getLabelProperties('10em', 'italic', 'middle', arealabelValue),
                    this.getLabelProperties('10em', 'normal', 'middle', ')')
                ]);
            }
        }

        labelValue = (attribute1 + attribute2 + attribute3 + attribute4).replace(new RegExp('\n$'), '');
        if (labelValue !== '') {
            labelProperties.labels = labels;
            labelProperties.labelExpression = labelValue;
            return labelProperties;
        } else {
            return null;
        }
    }
}
